// Musette's header: the wordmark left; on the right, the screen's label and the round K that
// opens You, the way iOS apps open your account. The label is a label, not a hidden button.
import { useLocation } from "preact-iso";

export function Head({ right }: { right: string }) {
  const { path } = useLocation();
  return (
    <header class="s-head">
      <a class="mark" href="/">musette</a>
      <span class="s-head-r">
        <span class="label ink">{right}</span>
        <a class={`avatar${path === "/you" ? " on" : ""}`} href="/you" aria-label="You: your rules, bikes, records and settings">K</a>
      </span>
    </header>
  );
}
